import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectUserState } from 'app/features/auth/store/selectors';
import { User } from 'app/features/users/models/user';
import { SignOut } from 'app/features/auth/store/actions';
import { environment } from 'environments/environment';
 
 @Component({
   selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  activeButton: string = '';
  isPopupVisible = false;
  @ViewChild('popup', { static: false }) popup: ElementRef;
  private subscription: Subscription = new Subscription();
  public adminUser: User;
  public isStaging: boolean = environment.name === 'Staging';
  constructor(
    private router: Router,
    private store: Store,
  ) { }
  ngOnInit(): void {
    this.subscription.add(
      this.store.select(selectUserState).subscribe((user: { data: User }) => {
        this.adminUser = user.data;
        if(!this.adminUser){
          this.router.navigate(['/onboarding']);
        }
      })
    );
    this.subscription.add(
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.setActiveButtonFromUrl(event.urlAfterRedirects);
        }
      })
    );

    this.setActiveButtonFromUrl(this.router.url);
  }

  setActiveButtonFromUrl(url: string): void {
    const slug = url.split('/')[1];
    this.activeButton = slug || 'users';
  }

  navigateTo(route: string): void {
    console.log('Navigating to', route);
    this.router.navigate([route]);
  }

  setActiveButton(button: string): void {
    this.activeButton = button;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
